import { CHANGE_MODE, ADD_PLANT_TO_SENSOR } from '../actions'

const INITIAL_STATE = {
    mode: 'general',
    data: {},
}

function ModeReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case CHANGE_MODE:
            return {
                ...state,
                mode: action.payload.mode,
                data: action.payload.data,
            }
        case ADD_PLANT_TO_SENSOR:
            return INITIAL_STATE
        default: return state
    }
}

export default ModeReducer



// WEBPACK FOOTER //
// ./src/reducers/modes.js